// import {
//     DoctorAuditListPage, DoctorListPage, MedicineListPage, PriceListPage,
//     OrderListPage, DrugStoreListPage,
//     HomePage, DoctorDetailPage, MedicineEditPage, DrugStoreAddPage, OrderDetailPage, PaymentSetPage
// } from 'src/components';

/**
 * 路由配置
 */
export namespace RouterConfig {
  interface IRouterUrl {
    auth: string;
    app: string;
    home: string;
    login: string;
    reset: string;
    user: string;
    userAudit: string;
    userDoctorNoSetting: string;
    userDoctor: string;
    userDoctorBatchModify: string;
    /** 记账机构管理 */
    bookKeeping: string;
    userAdmin: string;
    price: string;
    order: string;
    // orderMedicine: string;
    // orderPresctiption: string;
    drugStore: string;
    account: string;
    payment: string;
    /** 脉景收款账户 */
    wallet: string;
    /** mall-药库管理 */
    mallPharmacy: string;
    /** mall-药品管理 */
    mallMedicine: string;
    /** 部门管理 */
    departmentAdmin: string;
    default: string;
    notFound: string;
    /** 促销设置 */
    promotion: string;
  }

  export interface IMenuItems {
    [key: string]: any;
    menus: IMenuData[];
    others: IMenuData[];
  }

  // export interface IMenuInfo {
  //     path: string;
  //     name: string;
  //     component: string;
  //     icon?: string;
  // }

  // export interface IMenuPrimary extends IMenuInfo {
  //     subs: IMenuInfo[];
  // }

  export interface IMenuData {
    id?: number;
    name: string;
    tips?: string;
    desc?: string;
    path: string;
    component?: string;
    url?: string;
    icon?: string;
    data?: string;
    children?: IMenuData[];
  }

  /**
   * URL地址集合
   */
  export const Urls: IRouterUrl = {
    auth: '/auth',
    login: '/auth/login',
    reset: '/auth/reset',
    app: '/app',
    home: '/app/home',
    user: '/app/user',
    userAudit: '/app/user/audit',
    userDoctorNoSetting: '/app/doctor/setting',
    userDoctor: '/app/user/doctor',
    userDoctorBatchModify: '/app/user/doctorBatchModify',
    price: '/app/price', //
    order: '/app/order',
    // orderMedicine: '/app/order/medicine',
    // orderPresctiption: '/app/order/prescription',
    drugStore: '/app/drugStore',
    bookKeeping: '/app/bookKeeping/list',
    userAdmin: '/app/userAdmin',
    account: '/app/account',
    payment: '/app/payment',
    wallet: '/app/wallet',
    mallPharmacy: '/app/mall/pharmacy',
    mallMedicine: '/app/mall/medicine',
    departmentAdmin: '/app/departmentAdmin',
    default: '/app/home',
    notFound: '/404',
    promotion: '/app/promotion/list',
  };

  // /**
  //  * 代理商权限
  //  */
  // export const AgentRoles: string[] = [
  //     Urls.user,
  //     Urls.userAudit,
  //     Urls.userDoctor,
  //     Urls.medicine,
  //     Urls.price,
  //     Urls.order,
  //     // Urls.orderMedicine,
  //     // Urls.orderPresctiption,
  //     Urls.drugStore,
  //     Urls.payment,
  // ];

  // /**
  //  * 配药中心权限
  //  */
  // export const DrugStoreRoles: string[] = [
  //     Urls.user,
  //     Urls.userDoctor,
  //     Urls.medicine,
  //     Urls.price,
  //     Urls.order,
  //     // Urls.orderMedicine,
  //     // Urls.orderPresctiption,
  //     Urls.account,
  //     Urls.payment,
  // ];

  /**
   * 导航
   */
  export const MenuItems: IMenuItems = {
    menus: [
      {
        path: `${Urls.home}`,
        name: 'nav_home',
        icon: 'home',
        component: 'HomePage',
      },
      {
        path: `${Urls.user}`,
        name: 'nav_user',
        icon: 'user',
        children: [
          {
            path: `${Urls.userAudit}`,
            name: 'nav_user_audit',
            component: 'DoctorAuditListPage',
          },
          {
            path: `${Urls.userDoctorNoSetting}`,
            name: 'nav_user_doctor_no_setting',
            component: 'DoctorListPage',
          },
          {
            path: `${Urls.userDoctor}`,
            name: 'nav_user_doctor',
            component: 'DoctorListPage',
          },
        ],
      },
      {
        path: `${Urls.order}`,
        name: 'nav_order',
        icon: 'ordered-list',
        component: 'OrderListPage',
      },
      {
        path: `${Urls.drugStore}`,
        name: 'nav_drugStore',
        icon: 'appstore',
        component: 'DrugStoreListPage',
      },
      {
        path: `${Urls.bookKeeping}`,
        name: 'nav_bookKeeping',
        icon: 'setting',
        component: 'BookKeepingListPage',
      },
      {
        path: `${Urls.userAdmin}`,
        name: 'nav_userAdmin',
        icon: 'user',
        component: 'UserAdminListPage',
      },
      {
        path: `${Urls.account}`,
        name: 'nav_account_detail',
        icon: 'profile',
        component: 'DrugStoreAddPage',
      },
      {
        path: `${Urls.payment}`,
        name: 'nav_setting',
        icon: 'setting',
        component: 'PaymentSetPage',
      },
      {
        path: `${Urls.wallet}`,
        name: 'nav_wallet',
        icon: 'credit-card',
        component: 'WalletPage',
      },
      {
        path: `${Urls.mallPharmacy}`,
        name: 'nav_pharmacy',
        icon: 'medicine-box',
        component: 'MallPharmacyListPage',
      },
      {
        path: `${Urls.mallMedicine}`,
        name: 'nav_medicine',
        icon: 'medicine-box',
        component: 'MallMedicineListPage',
      },
      {
        path: `${Urls.departmentAdmin}`,
        name: 'nav_departmentAdmin',
        icon: 'user',
        component: 'DepartmentAdminListPage',
      },
      {
        path: `${Urls.promotion}`,
        name: 'nav_promotion',
        icon: 'profile',
        component: 'PromotionListPage',
      },
    ],
    others: [
      {
        path: `${Urls.userAudit}/:id`,
        name: 'nav_user_account_audit',
        component: 'DoctorDetailPage',
      },
      {
        path: `${Urls.userDoctor}/:id`,
        name: 'nav_user_doctor_detail',
        component: 'DoctorDetailPage',
      },
      {
        path: `${Urls.userDoctorBatchModify}`,
        name: 'doc_batch_modify',
        component: 'DoctorBatchModifyPage',
      },
      {
        path: `${Urls.drugStore}/add`,
        name: 'nav_drugStore_add',
        component: 'DrugStoreAddPage',
      },
      {
        path: `${Urls.order}/:id`,
        name: 'nav_drugStore_add',
        component: 'OrderDetailPage',
      },
      {
        path: `${Urls.userAdmin}/add`,
        name: 'nav_userAdmin_add',
        component: 'UserAdminEditPage',
      },
      {
        path: `${Urls.userAdmin}/:id`,
        name: 'nav_userAdmin_edit',
        component: 'UserAdminEditPage',
      },
      {
        path: `${Urls.wallet}`,
        name: 'nav_wallet',
        component: 'WalletPage',
      },
      {
        path: `${Urls.wallet}/register/individual`,
        name: 'nav_wallet',
        component: 'WalletRegisterPage',
      },
      {
        path: `${Urls.wallet}/register/enterprise`,
        name: 'nav_wallet',
        component: 'WalletRegisterPage',
      },
      {
        path: `${Urls.wallet}/bindCard`,
        name: 'nav_wallet',
        component: 'WalletBindCardPage',
      },
      {
        path: `${Urls.price}/change`,
        name: 'nav_price',
        component: 'PriceChangeRecordPage',
      },
      {
        path: `${Urls.price}/change/:id`,
        name: 'nav_price',
        component: 'PriceChangeDetailPage',
      },
      {
        path: `${Urls.mallPharmacy}/add`,
        name: 'pharmacy_add',
        component: 'MallPharmacyAddPage',
      },
      {
        path: `${Urls.mallPharmacy}/:uuid`,
        name: 'pharmacy_detail',
        component: 'MallPharmacyDetailPage',
      },
      {
        path: `${Urls.departmentAdmin}/detail/:uuid?`,
        name: 'departmentAdmin_detail',
        component: 'DepartmentAdminDetailPage',
      },
    ],
  };

  /**
   * 检查所有的menu项目是否符合条件
   * @param menus
   */
  export const checkMenuItems = (menus: IMenuData[]): boolean => {
    let result = true;
    for (const item of menus) {
      const checkResult = checkMenuItem(item);
      result = result && checkResult;
      if (!checkResult) {
        console.error('this router config error');
        console.error(item);
      }
    }
    return result;
  };

  /**
   * 检查单个menu项是否符合条件
   * PS: 1、如果父级存在component，那么不需要看children
   * 2、如果父级不存在component，那么需要看children中的每一个项目
   * @param menu
   */
  const checkMenuItem = (menu: IMenuData): boolean => {
    let result = true;
    if (!!menu.component) {
      result = true;
    } else {
      if (!!menu.children && menu.children.length > 0) {
        for (const child of menu.children) {
          result = result && checkMenuItem(child);
        }
      } else {
        result = false;
      }
    }
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/routers/urlConfig.ts